import { createReducer, on } from '@ngrx/store';
import { createEntitySlice, withEntityReducer } from '@aston/foundation';

import * as featureActions from './actions';
import { initialState, IFederationsState } from './state';


// declare our fully typed reducer
export const FederationsStoreReducer = createReducer<IFederationsState>(
	initialState,

	...withEntityReducer<IFederationsState>('federations', featureActions.federationsListActions),
	...withEntityReducer<IFederationsState>('form', featureActions.federationsEntityActions),

	on(featureActions.NewFederation, state => ({
		...state,
		form: createEntitySlice(),
	})),

	on(featureActions.LoadFederationsSuccess, (state, action) => ({
		...state,
		hasLoadedOnce: true,
		hasPendingItems: action.hasPendingItems,
	})),
);
